module.exports = __webpack_public_path__ + "img/181121_AWS_SauberIstIn_Plakat.7bc1ec95.jpg";